import { CommandGroup } from "~/core/ui/Command";

import { useGlobalCommandbarStore } from "../../store";

import CommandbarItem from "./CommandbarItem";

export default function PagesSection() {
  const commandbarPageItems = useGlobalCommandbarStore(
    st => st.commandbarPageItems,
  );

  if (commandbarPageItems.length === 0) return null;

  return (
    <CommandGroup
      heading="Pages"
      className="[&_[cmdk-group-heading]]:pt-0 [&_[cmdk-group-heading]]:font-normal"
    >
      {commandbarPageItems.map(command => (
        <CommandbarItem key={command.id} command={command} />
      ))}
    </CommandGroup>
  );
}
